import { render, staticRenderFns } from "./CrewFormModal.vue?vue&type=template&id=218963da&scoped=true"
import script from "./CrewFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrewFormModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CrewFormModal.vue?vue&type=style&index=0&id=218963da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218963da",
  null
  
)

export default component.exports